export default __webpack_public_path__ + "static/media/stake-more-gamer-weth.14808591.svg";